import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const haloPsa = defineConnector({
  identifier: "haloPsa",
  name: "Halo PSA",
  tagLine: "IT service management and PSA",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ hostname }) => domainToRegex(hostname),
  auth: oauthAuth,
  steps: [
    {
      title: "Create an API application in Halo PSA",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your Halo PSA instance and navigate to **Configuration > Integrations > Halo PSA API**. Click **View Applications**, then **New** to create an API application. Set the authentication method to ‘Client ID and Secret’.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "Hostname",
          placeholder: "example.halopsa.com",
          required: true,
          target: { kind: "configuration", field: "hostname" },
          helperText: "Your Halo PSA hostname (without https://)",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: (configuration) =>
      `https://${configuration.hostname}/auth/token`,
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => ["all"],
  },
  connectionTest: {
    protocol: "http",
    request: (configuration) => ({
      url: `https://${configuration.hostname}/api/Users?count=1`,
      expectedStatus: [200, 403],
    }),
  },
  publicEnvVars: ({ hostname }) => ({
    HALO_PSA_URL: hostname ? `https://${hostname}` : "",
  }),
});
